import { render, staticRenderFns } from "./RpcCategoryChart.vue?vue&type=template&id=58ec4f90"
import script from "./RpcCategoryChart.vue?vue&type=script&lang=js"
export * from "./RpcCategoryChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports